module.exports = __webpack_public_path__ + "img/ic_notification_job.c349adcc.svg";